<template lang="html">
  <nav aria-label="breadcrumb" class="status-bar-base">
    <div class="breadcrumb status-bar-base-inner bc m-0 px-1 py-2 mb-0 row justify-content-start">
      <Breadcrumb class="status-bar-breadcrumb" :items="breadcrumbs" :filters="filters" :noLinks="noLinks" />
      <div class="status-bar-mob-filters-link col-4 col-md-2 text-right pl-0 pr-1 mx-0"
           v-if="shareInfo"
           @click="openShareModal">
        <font-awesome-icon :icon="['fa', 'share']" />
        Compartir
      </div>
      <div class="status-bar-mob-filters-link d-flex d-sm-none"
           v-if="!noFilters"
           @click="handleOpenFilters">
        Filtrar{{ filtersNum ? ` (${filtersNum})` : '' }}
      </div>
      <OrderBy v-if="!noOrder && !shareInfo" class="d-none d-md-block col-2 pl-0"
               :filters="filtersSimples"
               @addFilter="filtersAddSimple" />
      <div class="d-none d-sm-block col-2"></div>
    </div>
  </nav>
</template>

<script>
import Breadcrumb from './Breadcrumb'
import store from '@/store'
import OrderBy from '@/components/filters/Order'
import filtersMixin from '@/mixins/filters'
import {instance as componentDialog} from '@/components/layout/ComponentDialog'
import SocialNetworkShare from '@/components/layout/SocialNetworkShare'

export default {
  mixins: [
    filtersMixin
  ],

  components: {
    Breadcrumb,
    SocialNetworkShare,
    OrderBy
  },

  props: {
    breadcrumbs: Array,
    report: Boolean,
    filters: Object | null,
    noLinks: Boolean,
    noFilters: Boolean,
    shareInfo: Object,
    noOrder: Boolean
  },

  computed: {
    backward () {
      const oneback = Array.isArray(this.breadcrumbs) &&
        this.breadcrumbs[this.breadcrumbs.length - 2]

      return oneback ? oneback.path : '/'
    },

    distanceFilter: () => store.state.search.distance !== -1 ? 1 : 0,

    simpleFilters: () => store.state.filters.simples || [],

    filtersNum () {
      // When Order by is implemented, the sort_by won't be in the simpleFilters anymore
      const removeQueries = this.simpleFilters.filter(f => f.key !== 'q')
      return removeQueries.length + this.distanceFilter
    },
  },

  methods: {
    openShareModal () {
      this.pushToDataLayer('Status bar', 'Share menu open')
      componentDialog({
        component: SocialNetworkShare,
        header: 'Compartir',
        backdrop: true,
        props: {
          info: this.shareInfo
        }
      })
    },

    handleOpenFilters () {
      this.$emit('openMobileFilters')
      this.pushToDataLayer('Status bar', 'Filters menu open')
    }
  }
}
</script>

<style lang="scss">
  @import '/../../scss/aspect';
  @import '/../../scss/colors';
  @import '/../../scss/breakpoints';

  .status-bar-base {
    & .fa {
      font-size: 150%;
      text-align: center;
      color: $secondary;
    }

    // padding-top: 4px;
    padding-left:  calc(50% - (#{$max-width} / 2));
    padding-right:  calc(50% - (#{$max-width} / 2));
    background-color: $gray-200;
    z-index: 2;

    & li {
      display: inline-block;
    }
  }

  .bc {
    font-size: 0.8rem;
    font-weight: bold;
    display: flex !important;
    color: $gray-600;
    justify-content: space-between !important;
    width: 100%;
    position: sticky !important;
  }

  /*add later to make sticky menu */
  .bc-sticky {
    position: fixed !important;
    z-index: 1;
  }

  .bc-companion,
  .bc-companion li p,
  ol {
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .status-bar-mob-filters-link {
    cursor: pointer;
  }

  .status-bar-breadcrumb {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .status-bar-base {
      // margin-top: 2.8rem;
      margin-top: 0;
      padding-top: 0;

      & .fa {
        color: $white;
      }

      &-inner {
        display: flex !important;
        background-color: $primary;
        height: 3rem;
        border-radius: 0;
      }
    }

    .status-bar-mob-filters-link {
      margin: auto 1rem auto 0;
      color: #FFF;
      font-size: 0.9rem;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/StatusBarBase.vue